export default __webpack_public_path__ + "static/media/phone-base.270b1675.png";